import { promptChainApi } from '@/services/promptChainApi';
import { executionPolling } from '@/utils/pollingService';
import { rationaleDraftRun } from '@rm-ui/levelling/rationaleDraftRun';

/**
 * AI rationale drafting (PD-1301) — "Use Atlas" in the rationale editor.
 *
 * The runner lives in `shared/ui/src/levelling/rationaleDraftRun.js` so rm-portal
 * and rm-portal-beta fire the same chain with the same inputs and read the
 * result the same way. This wrapper injects this portal's prompt-chain client
 * and polling service, exactly as useDocReadinessCheck does for readiness.
 */
export function useRationaleDraft() {
  return rationaleDraftRun({ promptChainApi, executionPolling });
}
